<template>
  <div class="demo-call-user">
    <div class="form-container">
      <CallUserForm @call="onCall"/>
    </div>
    <div v-if="error">{{error}}</div>
    <div v-if="ringing">Ringing...</div>
  </div>
</template>

<script>
  import CallUserForm from "../components/forms/CallUserForm";
  import {callUser} from "../services/apollo/call";

  export default {
    components: {CallUserForm},

    data: () => ({
      error: null,
      ringing: false
    }),

    methods: {
      onCall(phone) {
        this.error = null;
        this.ringing = false;
        callUser(phone)
          .then(() => {
            this.ringing = true;
          })
          .catch(err => {
            this.error = err.message;
          })
      }
    }
  }
</script>

<style lang="scss">
  .demo-call-user {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;

    .form-container {
      padding: 30px 50px;
      border: 1px solid #999999;
      border-radius: 10px;
    }
  }
</style>
